import { styled } from "goober";

export const LabelWithInfo = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;
